'use strict';
/* There are some recipe events on this page due to the shared namespace of wishlist */

var addProductToCart = require('./product/addToCart'),
	ajax = require('../ajax'),
	page = require('../page'),
	login = require('../login'),
	dialog = require('../dialog'),
	util = require('../util'),
	linchpin = require('int_googletagmanager/linchpin/wishlist');

exports.init = function () {
	login.init();
	addProductToCart();

	$('#editAddress').on('change', function () {
		page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
	});
	$('.wl-info-dialog').on('click touchstart', function (e) {
		e.preventDefault();
		var url = $(this).attr('href');
		dialog.open({
			url: url,
			options:{
				dialogClass: 'wishlist-info-dialog',
			}
		});
	});
	$('.saved-hamper').on('click touchstart', function (e) {
		e.preventDefault();
		var hampers = require('./product/hampers');
		var url = $(this).attr('href');
		var plid = $(this).data('plid');
		var pids = [];
		ajax.getJson({
			url: Urls.getHamperErrors,
			data: {id: plid},
			callback: function (data) {
				if (typeof data.containerErrors !== 'undefined') {
					if (data.containerErrors.indexOf('outofstock') >= 0 || data.containerErrors.indexOf('unavailable') >= 0) {
						pids.push(data.containerProduct);
					}
					if (data.containerErrors.indexOf('componenterror') >= 0) {
						for (var i = 0; i < data.componentProducts.length; i++) {
							if (data.componentProducts[i].errors.length > 0) {
								pids.push(data.componentProducts[i].pid);
							}
						}
					}
					if (pids.length > 0) {
						hampers.itemUnavailableDialog(pids, function () {
							window.location.href = url;
						});
					} else {
						// if there were no expected errors, follow the link
						window.location.href = url;
					}
				} else {
					// display a generic error message
					dialog.open({
						url: Urls.requestErrorMessage,
						options: {
							buttons: [
								{
									text: Resources.GOT_IT,
									click: function () {
										$(this).dialog('close');
									}
								}
							],
							title: Resources.SORRY
						}
					});
				}
			}
		});
	});

	// This wishlist remove event is shared with recipe remove event
	$('#wishlist-table .option-update .delete-item').on('click', function (e) {
		if ($('input[name=gtmlist]').val() === 'wishlist') {
			var pid = $('#wishlist-table').find('.item-details').find('span:nth(1)').text();
			var price = $('#wishlist-table').find('.item-details').find('.price-sales').text();
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.removeFromWishlistEvent(e, pid, price);
			}
		} else if ($('input[name=gtmlist]').val() === 'recipe') {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				var product = $(this).attr('data-id');
				linchpin.removeRecipeEvent(e, product);
			}
		}
	});

	// REMOVED click events - GTM viewWishlistEvent()

	if ($('#wishlist-table').length > 0) {
		if ($('input[name=gtmlist]').val() === 'wishlist') {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.viewWishlistEvent();
			}
		}
	}
};

exports.initCurrentCustomerWishlist = function () {
	var wishlistNumItemsElement = $('.wishlist-items-number');
	if (wishlistNumItemsElement.length) {
		if (wishlistNumItemsElement.html().trim() === '') {
			var guestWishlistID = window.localStorage.getItem('wishlistID');
			var url = guestWishlistID ? util.appendParamsToUrl(Urls.getWishlistProductList, {guestWishlistID: guestWishlistID}) : Urls.getWishlistProductList;
			ajax.load({
				url: url,
				callback: function (response, errorStatus) {
					if (!response || errorStatus) {
						window.console.error('The error ocured for call, error status: ', errorStatus);
						return;
					}

					try {
						var responseObj = response;
						if (typeof(response) === 'string') {
							responseObj = JSON.parse(response);
						}
					} catch (e) {
						window.console.error(e);
						return;
					}

					updateHeaderDisplay(responseObj);
					markWishlistProducts();

					// Save/remove wishlist to localStorage
					var customerWishlistID = responseObj.wishlistID;
					if (window.User.cleanLocalStorageWishlist) {
						window.localStorage.removeItem('wishlistID');
					} else if (SitePreferences.IS_WISHLIST_LONGTERM_AVAILABLE && customerWishlistID) {
						window.localStorage.setItem('wishlistID', customerWishlistID);
					}

					appendLoginAndRegistrationForms(customerWishlistID);
				}
			});
		}

		handleWishlistUpdate('.add-to-wishlist');
		handleWishlistUpdate('.remove-from-wishlist');
	}
};

// Add wishlist to login/register form, if exists in localStorage
function appendLoginAndRegistrationForms (customerWishlistID) {
	var wishlistId = customerWishlistID || window.localStorage.getItem('wishlistID');
	var $wishlistInput = $('form input[name="guestWishlistID"]');

	if (wishlistId && $wishlistInput.length) {
		$wishlistInput.val(wishlistId);
	}
}

function updateHeaderDisplay(responseObj) {
	var wishlistProducts = responseObj ? responseObj.wishlistProductIDs : null;
	if (!$.isEmptyObject(wishlistProducts)) {
		$('.wishlist-items-number').html(wishlistProducts.length);
		$('.wishlist-items-number').attr('data-wishlist', JSON.stringify(wishlistProducts));
	} else {
		$('.wishlist-items-number').empty();
		$('.wishlist-items-number').attr('data-wishlist', '[]');
	}
}

function openDialog(wishlistDialogEl) {
	dialog.open({
		html: wishlistDialogEl.html(),
		options: {
			dialogClass: 'wishlist-dialog',
			minHeight: 30
		},
		callback: function () {
			setTimeout(function () {
				if ($('.wishlist-dialog:visible').length) {
					dialog.close();
				}
			}, 40000);
		}
	});
	$('.ui-widget-overlay').on('click', function() {
		dialog.close();
	});
}

function handleWishlistUpdate(actionSelector) {
	$(document).on('click', actionSelector, function (e) {
		e.preventDefault();
		e.stopPropagation();
		var actionElement = $(this);
		var url = actionElement.attr('href');
		ajax.load({
			url: url,
			callback: function (response, errorStatus) {
				if (!response || errorStatus) {
					window.console.error('The error ocured for call, error status: ', errorStatus);
					return;
				}

				try {
					var responseObj = response;
					if (typeof(response) === 'string') {
						responseObj = JSON.parse(response);
					}
				} catch (error) {
					window.console.error(error);
					return;
				}

				updateHeaderDisplay(responseObj);
				actionElement.addClass('hidden');
				var wishlistProducts = responseObj.wishlistProductIDs;
				var productInWishList = false;
				for (var i = 0; i < wishlistProducts.length; i++) {
					var productID = actionElement.siblings('[name="productID"]').val();
					if (productID === wishlistProducts[i].productID || productID === wishlistProducts[i].masterID) {
						productInWishList = true;
						break;
					}
				}
				if (productInWishList && actionElement.hasClass('add-to-wishlist')) {
					actionElement.siblings('.remove-from-wishlist').removeClass('hidden');
					openDialog(actionElement.siblings('.wishlist-add-product-dialog'));
				} else if (actionElement.hasClass('remove-from-wishlist')) {
					actionElement.siblings('.add-to-wishlist').removeClass('hidden');
					openDialog(actionElement.siblings('.wishlist-remove-product-dialog'));
				}
			}
		});
	});
}

function markWishlistProducts() {
	var productIDs = $('[name="productID"]');
	var wishlistProducts;
	try {
		wishlistProducts = JSON.parse($('.wishlist-items-number').attr('data-wishlist'));
	} catch (e) {
		window.console.error(e);
		return;
	}
	if (productIDs.length && wishlistProducts.length) {
		wishlistProducts.forEach(function (wishlistProduct) {
			for (var i = 0; i < productIDs.length; i++) {
				var productID = $(productIDs[i]);
				var masterID = $('[itemprop="productID"]').length ? $('[itemprop="productID"]').attr('data-masterid') : '';
				var masterIDCheck = masterID ? wishlistProduct.masterID === masterID : false;
				if (wishlistProduct.productID === productID.val() || wishlistProduct.masterID === productID.val() || masterIDCheck) {
					productID.siblings('.add-to-wishlist').addClass('hidden');
					productID.siblings('.remove-from-wishlist').removeClass('hidden');
					break;
				}
			}
		});
	}
}
exports.markWishlistProducts = markWishlistProducts;
